import {
  CHANNEL_KIND_LABEL,
  DELIVERY_MODE_LABEL,
  PURPOSE_LABEL,
  type AudienceReachabilityPreview,
  type CampaignChannelKind,
  type CampaignDeliveryMode,
  type CampaignPurpose,
} from '@workspace/types';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { channelDataLabel } from '../api/campaignWizardRules';

export function CampaignWizardReview({
  name,
  onName,
  purpose,
  deliveryMode,
  channelKind,
  templateLabel,
  whenLabel,
  reachPreview,
  autoReplyText,
}: {
  name: string;
  onName: (value: string) => void;
  purpose: CampaignPurpose;
  deliveryMode: CampaignDeliveryMode;
  channelKind: CampaignChannelKind;
  templateLabel: string;
  whenLabel: string;
  reachPreview: AudienceReachabilityPreview | null;
  autoReplyText: string;
}) {
  const reachable = reachPreview?.reachableCount ?? 0;
  const missing = reachPreview?.unreachableCount ?? 0;
  return (
    <div className='md:col-span-2 space-y-4'>
      <div className='space-y-2'>
        <Label htmlFor='campaign-name'>Nombre</Label>
        <Input
          id='campaign-name'
          value={name}
          maxLength={255}
          onChange={event => onName(event.target.value)}
        />
      </div>
      <Card className='rounded-xl'>
        <CardContent className='space-y-2 p-6 text-sm'>
          <p>
            {PURPOSE_LABEL[purpose]} · {DELIVERY_MODE_LABEL[deliveryMode]} · {CHANNEL_KIND_LABEL[channelKind]}
          </p>
          <p>
            {reachable} alcanzables · {missing} sin {channelDataLabel(channelKind)}
          </p>
          <p>Plantilla: {templateLabel}</p>
          <p>Cuándo: {whenLabel}</p>
          {deliveryMode === 'NOTIFICATION' ? (
            <p>
              Respuesta automática:{' '}
              {autoReplyText.trim()
                ? autoReplyText.trim().slice(0, 120) + (autoReplyText.trim().length > 120 ? '…' : '')
                : 'sin configurar'}
            </p>
          ) : null}
          <p className='text-muted-foreground'>
            Guardar no envía mensajes. En el tablero iniciás con confirmación.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
